export const getCardsData = ({data: item}) => {

    if (!item || (typeof item === 'object' && !Array.isArray(item) && Object.keys(item).length === 0)) {
        return [];
    }

    const amount = item?.overall?.netProfit;
    const isProfit = Number(amount) >= 0;
    console.log("item",item)
    return [
        {
            id: 1,
            title: "Financial Health",
            subTitle: {[isProfit ? 'Net Profit' : 'Net Loss']: `₹ ${item?.overall?.netProfit || 0}`},
            subTitleColor: isProfit ? 'text-success' : 'text-danger',
            icon: isProfit ? 'trendingUp' : 'trendingDown',
            iconBgColor: isProfit ? 'success' : 'danger',
            column: 'col-6 col-md-6',
            items: [
                {'Total Expense': `₹ ${item?.overall?.totalExpense}`},
                {'Total Income': `₹ ${item?.overall?.totalIncome}`},
            ]
        },
        {
            id: 2,
            title: "Order Revenue",
            subTitle: {
                'Order Amount': `₹ ${item?.OrderSummary?.[0]?.totalFinalAmount || 0}`
            },
            icon: 'burger',
            iconBgColor: 'danger',
            column: 'col-6 col-md-6',
            items: [
                { 'Total Orders': item?.OrderSummary?.[0]?.totalOrders ?? 0 },
                { 'Total Payment': `₹ ${item?.OrderSummary?.[0]?.totalFinalAmount ?? 0}` },
                { 'Paid Payment': `₹ ${item?.OrderSummary?.[0]?.totalPaid ?? 0}` },
                { 'Due Payment': `₹ ${item?.OrderSummary?.[0]?.totalDue ?? 0}` },
            ]
        },
        {
            id: 3,
            title: "Customer Revenue",
            subTitle: {
                'Invoice Amount': `₹ ${item?.expenseByInvoice?.[0]?.totalBill || 0}`,
            },
            icon: "person",
            iconBgColor: "info",
            column: 'col-6',//To set the title width inside card
            items: [
                {'Total Invoices': item?.expenseByInvoice?.[0]?.totalInvoices || 0},
                {'Total Payment': `₹ ${item?.expenseByInvoice?.[0]?.totalBill || 0}`},
                {'Paid Payment': `₹ ${item?.expenseByInvoice?.[0]?.totalPayment || 0}`},
                {'Pending Payment': `₹ ${item?.expenseByInvoice?.[0]?.pendingPayment || 0}`},
            ]
        },
        {
            id: 4,
            type: "Expense",
            title: "Expense By Category",
            subTitle: {'Total Expense': `₹ ${item?.overall?.totalExpense}`},
            icon: "receipt",
            iconBgColor: "warning",
            column: 'col-6 col-md-4',//To set the title width inside card
            items: [
                ...(item?.expenseByType ?? []).map(({typeName, amount}) => ({
                    [typeName]: `₹ ${Number(amount).toFixed(2)}`
                }))
            ]
        },
        // {
        //     id: 5,
        //     title: "Income By Category",
        //     subTitle: {'Total Income': `₹ ${item?.overall?.totalIncome}`},
        //     icon: "burger",
        //     iconBgColor: "secondary-subtle",
        //     column: 'col-6 col-md-4',
        //     items: [
        //         ...(item?.incomeByType ?? []).map(({typeName, amount}) => ({
        //             [typeName]: `₹ ${Number(amount).toFixed(2)}`
        //         }))
        //     ]
        // },
        // {
        //     id: 6,
        //     title: "Income By Services",
        //     subTitle: {'Total Income': `₹ ${item?.overall?.totalIncome}`},
        //     icon: "service",
        //     iconBgColor: "info-subtle",
        //     column: 'col-6 col-md-4',
        //     items: [
        //         ...(item?.incomeByService ?? []).map(({serviceType, amount}) => ({
        //             [serviceType]: `₹ ${Number(amount).toFixed(2)}`
        //         }))
        //     ]
        // },
        // {
        //     id: 7,
        //     title: "Income By Tag",
        //     subTitle: {'Total Income': `₹ ${item?.overall?.totalIncome}`},
        //     icon: "tag",
        //     iconBgColor: "dark-subtle",
        //     column: 'col-6 col-md-4',
        //     items: [
        //         ...(item?.incomeByTag ?? []).map(({tagName, amount}) => ({
        //             [tagName]: `₹ ${Number(amount).toFixed(2)}`
        //         }))
        //     ]
        // },
        {
            id: 8,
            title: "Expense By Vendor",
            type: "Expense",
            subTitle: {
                'Purchase Amount': `₹ ${item?.vendorSummary?.reduce(
                    (sum, v) => sum + (v.totalPurchaseAmount || 0),
                    0
                )}`
            },
            cardColumn: 'col-6 col-md-4', //To set the card width
            icon: "vendor",
            iconBgColor: "dark-subtle",
            ui: "table",
            tableColumns: [
                {header: "Name", field: "vendorName"},
                {header: "Total", field: "totalPurchaseAmount"},
                {header: "Paid", field: "totalPaymentAmount"},
                {header: "Due", field: "totalDueAmount"}
            ],
            items: item?.vendorSummary
        },
        {
            id: 9,
            title: "Income from Invoiced Customers",
            type: "Expense",
            cardColumn: 'col-6 col-md-4',//To set the card width
            ui: "table",
            subTitle: {
                'Total Invoice Amount': `₹ ${item?.expenseByInvoice?.[0]?.totalBill || 0}`,
            },
            icon: "person",
            tableColumns: [
                {header: "Name", field: "customerName"},
                {header: "Count", field: "totalInvoices"},
                {header: "Total", field: "totalAmount"},
                {header: "Paid", field: "paidAmount"},
                {header: "Due", field: "dueAmount"}
            ],
            iconBgColor: "info",
            items: item?.inviceByCustomer
        }
    ];
}

